import BannerForm from "components/banners/BannerForm";
import { createBanner } from "api/banner.api"; 
import { useBanners } from "components/banners/hooks/useBanners";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Alert from "components/common/Alert";


export default function BannerContainerPage() {
  
    const [alert, setAlert] = useState({ type: "", message: "" });
    const LIST_ROUTE_BY_TYPE = {
      Hero: "/admin/banners/herolist",
      Popup: "/admin/banners/popuplist",
      Bubble: "/admin/banners/bubblelist", 
      Flash: "/admin/banners/flashlist", 
    };
//   const handleSubmit = async (formData) => {
//     try {
//     await createBanner(formData);
//   }catch (err) {
//     console.error(
//       "API ERROR:",
//       err.response?.data || err.message
//     );
//      setAlert(
//     err.response?.data?.message ||
//     "Something went wrong. Try again."
//   );
//   }
// }
//   return <BannerForm
//   onSubmit={handleSubmit}
//   onClose={()=>{}} />;

   const navigate = useNavigate();
    // const { createBanner } = useBanners();
    const companyId = localStorage.getItem("company_id");
    const userId = "69579c6190a653b640e65639";
  
    return (<>
    {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          autoClose
        />
      )}
      <BannerForm
        onSubmit={async (fd) => {
          fd.append("company_id", companyId);
          fd.append("created_by", userId);
          try {
          await createBanner(fd);
          setAlert({
              type: "success",
              message: "Banner Created successfully",
            });
          navigate((LIST_ROUTE_BY_TYPE[fd.get("banner_type")]));
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Something went wrong while deleting Banner",
            });
          }
        }}
        onClose={() => navigate("/admin/banners/herolist")}
      />
      </>
    );
}
